import React from 'react';
import { BaseRatesGrid } from '../../grids';

const BaseRatesTab: React.FC = () => {
  return <BaseRatesGrid />;
};

export default BaseRatesTab;
